import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_TELEFONE_SICHTBAR_ADMIN = '[BenutzerverwaltungModul] PostBenutzerTelefoneSichtbarAdmin laden';
export const POST_BENUTZER_TELEFONE_SICHTBAR_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerTelefoneSichtbarAdmin ausführen';
export const POST_BENUTZER_TELEFONE_SICHTBAR_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerTelefoneSichtbarAdmin laden erfolgreich';
export const POST_BENUTZER_TELEFONE_SICHTBAR_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerTelefoneSichtbarAdmin Ladefehler';
export const POST_BENUTZER_TELEFONE_SICHTBAR_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerTelefoneSichtbarAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerTelefoneSichtbarAdminAction implements Action {
    readonly type = POST_BENUTZER_TELEFONE_SICHTBAR_ADMIN;
        constructor(public benutzerTelefoneSichtbarkeitRequest: api.BenutzerTelefoneSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefoneSichtbarAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_TELEFONE_SICHTBAR_ADMIN_AUSFUEHREN;
        constructor(public benutzerTelefoneSichtbarkeitRequest: api.BenutzerTelefoneSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefoneSichtbarAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_TELEFONE_SICHTBAR_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerTelefoneSichtbarkeitRequest: api.BenutzerTelefoneSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefoneSichtbarAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_TELEFONE_SICHTBAR_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerTelefoneSichtbarkeitRequest: api.BenutzerTelefoneSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefoneSichtbarAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_TELEFONE_SICHTBAR_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerTelefoneSichtbarAdminActions =
    PostBenutzerTelefoneSichtbarAdminAction
    | PostBenutzerTelefoneSichtbarAdminAusfuehrenAction
    | PostBenutzerTelefoneSichtbarAdminErfolgreichAction
    | PostBenutzerTelefoneSichtbarAdminFehlerAction
    | PostBenutzerTelefoneSichtbarAdminNichtAusgefuehrtAction
    ;
